import(/* webpackMode: "eager" */ "/vercel/path0/src/app/global-error.tsx")